var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "waf-tabs" }, [
    _c("ul", { staticClass: "tabs-wrap" }, [
      _c("li", { class: { active: _vm.isActive("teams") } }, [
        _c(
          "a",
          { attrs: { href: _vm.getTabLink(_vm.current_match, "teams") } },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.translations["lineup_ndtv_label"]) +
                "\n      "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("li", { class: { active: _vm.isActive("tips") } }, [
        _c(
          "a",
          { attrs: { href: _vm.getTabLink(_vm.current_match, "tips") } },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.translations["match_info_ndtv_label"]) +
                "\n      "
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }